import React, { useEffect } from 'react'
import NoResultsContainer from '../NoResults/NoResults'
import { useByStudent } from '../ByStudentContext/ByStudentContext'
import Loading from '../../../../../Loading/Loading'
import { useSelector } from 'react-redux'
import LearningGrowthColumn from '../../../../../commom/AnaCharts/LearningGrowthColumn'

const LearningGrowthColumnContainer = () => {
  const { studentSelected, curriculumId, onLoadLearningGrowthColumn, loading, dataChart, currentCurriculum } =
    useByStudent()
  const state = useSelector((state) => state?.filter?.learningMatrix || {})

  useEffect(() => {
    if (curriculumId && studentSelected) {
      onLoadLearningGrowthColumn(curriculumId, studentSelected, state.filter)
    }
  }, [curriculumId, studentSelected, state.filter])

  return (
    <div className='absolute inset-0'>
      {loading ? (
        <Loading />
      ) : dataChart?.length > 0 ? (
        <LearningGrowthColumn
          chartID='learning-growth-chart'
          dataSet={{
            datasets: dataChart,
            levels: currentCurriculum.levels.map((level, value) => ({
              ...level,
              value: value
            }))
          }}
        />
      ) : (
        <NoResultsContainer />
      )}
    </div>
  )
}

export default LearningGrowthColumnContainer
